import {JurisdictionData, SteJurisdictionParm, TaxItemInfo} from "@app/shared/classes/tax-information";
import {User} from "@app/shared/classes/user";
import {DocFile} from "@app/shared/classes/doc-file";
import {AddressInfo} from "@app/shared/classes/address";
import {W4Type} from "@app/shared/enums/w4-type.enum";
import {Type} from "class-transformer";
import {serializeType} from "@app/shared/classes/common";

export class PayrollPayeeW4Form {
  id: number;
  version: number;
  year: string;
  @Type(serializeType(User)) payee: User;
  @Type(serializeType(DocFile)) federalW4: DocFile;
  @Type(serializeType(DocFile)) stateW4: DocFile;
  payeeId: number;
  federalW4Id: number;
  stateW4Id: number;
}

export class PayrollPayeeW4Parm {
  id: number;
  version: number;
  year: string;
  w4Type: W4Type;
  parmName: string;
  parmValue: string;
  @Type(serializeType(User)) payee: User;
  @Type(serializeType(SteJurisdictionParm)) jurisdictionParm: SteJurisdictionParm;

  payeeId: number;
  jurisdictionParmId: number;
}


export class PayeeW4Info {

  userId: number;
  fullName: string;
  federalW4Id: number;
  federalW4FileName: string;
  stateW4Id: number;
  stateW4FileName: string;
  @Type(serializeType(PayrollPayeeW4Parm)) w4Parms: PayrollPayeeW4Parm[];
  @Type(serializeType(PayrollPayeeW4Form)) payrollPayeeW4Form: PayrollPayeeW4Form;

}

export class ParamListResponse {

  locationCode: string;
  infoMessage: string;
  workLocationMessage: string;

  @Type(serializeType(AddressInfo)) addressInfo: AddressInfo;
  @Type(serializeType(TaxItemInfo)) taxItemInfo: TaxItemInfo[];
  @Type(serializeType(JurisdictionData)) jurisdictionData: JurisdictionData[];

  parameterNameMap: Map<string, Array<string>>;                 // Map<String, Set<String>>
  // parameterValueMap: Map<W4Type, Map<string, string>>;          //Map<W4Type, Map<String, String>>
  parameterValueMap: any;                                       //Map<W4Type, Map<String, String>>
  @Type(serializeType(PayrollPayeeW4Form)) payrollPayeeW4Form: PayrollPayeeW4Form;
}
